import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import ProductReferenceResponse from "../../../api/models/ProductReferenceResponse";
import { ProductsAutocomplete } from "../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import StyledTooltip from "../../../components/Wrapper/StyledTooltip";
import ProductEditData from "../DescriptionTab/ProductEditData.model";
import { CompetitorProductReferenceResponse } from "../../../api/models/CompetitorProductReference";
import { PrototypeProductReferenceResponse } from "../../../api/models/PrototypeProductReference";
import {
  getCompetitorProductFullName,
  getPrototypeProductFullName,
} from "../DescriptionTab/forms/productReferenceHelper";

const useStyles = makeStyles({
  hideChip: {
    "& .MuiAutocomplete-tag": {
      backgroundColor: "inherit",
      pointerEvents: "none",

      "& .MuiChip-label": {
        paddingLeft: 0,
      },
    },
  },
});

interface CustomTagProps {
  data: ProductReferenceResponse & CompetitorProductReferenceResponse & PrototypeProductReferenceResponse;
  disabled: boolean;
  onDelete: () => void;
}

const CustomTag: React.FC<CustomTagProps> = ({ data, disabled, onDelete, ...restTagProps }) => {
  let name;
  switch (true) {
    case Boolean(data.nart):
      name = data?.nart || "";
      break;
    case Boolean(data.baseProduct):
      name = data?.baseProduct || "";
      break;
    case Boolean(data.productName):
      name = data?.productName || "";
      break;
    case Boolean(data.competitorProductName):
      name = getCompetitorProductFullName(data?.competitorProductName, data?.competitorCompanyName);
      break;
    case Boolean(data.prototypeProductName):
      name = getPrototypeProductFullName(data?.prototypeProductName, data?.prototypeProductResponsibleLaboratoryName);
      break;
    default:
      name = "";
      break;
  }
  return (
    <StyledTooltip title={data.nart || ""} {...restTagProps}>
      <Chip label={name} />
    </StyledTooltip>
  );
};

const LABEL = "Product(s) suggested by the requester";
const PLACEHOLDER = "Not defined by requester";

interface ProductSuggestionsProps {
  onTagClick?: (productEditData: ProductEditData<ProductReferenceResponse>) => void;
  values: (ProductReferenceResponse & CompetitorProductReferenceResponse & PrototypeProductReferenceResponse)[];
}

const ProductSuggestions: React.FC<ProductSuggestionsProps> = ({ values, onTagClick: handleTagClick }) => {
  const classes = useStyles();

  return (
    <ProductsAutocomplete
      className={!values.length ? classes.hideChip : ""}
      disabled
      customTag={CustomTag}
      inputLabel={LABEL}
      map={(data, idx) => {
        let name;
        switch (true) {
          case Boolean(data?.nart):
            name = data.nart || "";
            break;
          case Boolean(data.baseProduct):
            name = data?.baseProduct || "";
            break;
          case Boolean(data.productName):
            name = data?.productName || "";
            break;
          case Boolean(data.competitorProductName):
            name = getCompetitorProductFullName(data?.competitorProductName, data?.competitorCompanyName);
            break;
          case Boolean(data.prototypeProductName):
            name = getPrototypeProductFullName(
              data?.prototypeProductName,
              data?.prototypeProductResponsibleLaboratoryName,
            );
            break;
          default:
            name = "";
            break;
        }
        return { key: name + idx, label: name };
      }}
      onChange={() => {}}
      onTagClick={handleTagClick}
      optionFetch={() => {
        return Promise.resolve({
          data: [],
          totalPages: 0,
        });
      }}
      tagColorSecondary={() => true}
      value={values.length ? values : [{ name: PLACEHOLDER }]}
    />
  );
};

export default ProductSuggestions;
